var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { isGeoObject, isPart, isPoint } from '../../../../utils';
import { useArrayField, useField } from '../hooks';
import { route, routeItem } from '../paths';
import { createDraftAddress } from './selectors';
export var useRoute = function () {
    var _a = useArrayField(route), originMeta = _a[0], originHelpers = _a[1];
    var helpers = useMemo(function () { return (__assign(__assign({}, originHelpers), { push: function () { return originHelpers.push(createDraftAddress()); }, clear: function (index) { return originHelpers.clear(index, createDraftAddress()); } })); }, [originHelpers]);
    return [originMeta, helpers];
};
export var useAddress = function (index) {
    var path = useMemo(function () { return routeItem(index, 'address'); }, [index]);
    var _a = useField(path), _b = _a[0], value = _b.value, error = _b.error, touched = _b.touched, _c = _a[1], setValue = _c.setValue, setTouched = _c.setTouched;
    var field = {
        value: (value === null || value === void 0 ? void 0 : value.geoObject) || (value === null || value === void 0 ? void 0 : value.part),
        error: error,
        touched: touched,
    };
    var helpers = useMemo(function () { return ({
        setValue: function (value, shouldValidate) {
            if (isPart(value)) {
                return setValue({ part: value }, shouldValidate);
            }
            if (isGeoObject(value)) {
                return setValue({ geoObject: value }, shouldValidate);
            }
            if (isPoint(value)) {
                return setValue({ point: value }, shouldValidate);
            }
            throw new Error("unknown type of value: " + typeof value + ", " + value);
        },
        setTouched: setTouched,
    }); }, [setTouched, setValue]);
    return [field, helpers];
};
var createAddressExtra = function (extra) {
    return function (index) {
        var path = useMemo(function () { return routeItem(index, extra); }, [index]);
        return useField(path);
    };
};
export var useAddressFloor = createAddressExtra('floor');
export var useAddressContactPhone = createAddressExtra('contactPhone');
export var useAddressComment = createAddressExtra('comment');
export var useAddressApartment = createAddressExtra('apartment');
export var useAddressDoorCode = createAddressExtra('doorCode');
export var useAddressPorch = createAddressExtra('porch');
